var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RowLayout, styled, Text } from '@a0/quantum-product';
import * as React from 'react';
import performSearchAction from '../../../action/performSearch';
import SearchService from '../../../services/SearchService';
import { SearchResultState } from '../../../stores/SearchStore';
import { useFluxible } from '../../hooks/useFluxible';
import { ContentContainer } from '../../layouts';
import { Pagination } from '../../Pagination';
import { GlossaryTermWidget } from './GlossaryTermWidget';
import { SearchResults } from './SearchResult/SearchResults';
var SearchContainer = styled(ContentContainer)(function (_a) {
    var theme = _a.theme;
    return ({
        maxWidth: theme.layout.mobileBreakpoint,
        margin: '0 auto',
        padding: theme.spacing(0, 3),
    });
});
export var SearchPage = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var terms = _a.terms, result = _a.result, query = _a.query, page = _a.page;
    var executeAction = useFluxible().executeAction;
    React.useEffect(function () {
        if (query) {
            executeAction(performSearchAction, { query: query, page: page });
        }
    }, []);
    var selectResult = function (_a) {
        var id = _a.id, url = _a.url;
        SearchService.recordClickthrough(query, id, url);
    };
    var handlePageChange = function (page) {
        executeAction(performSearchAction, { query: query, page: page });
    };
    var title = result ? 'Search Results' : 'Search';
    var matchedTerm = (result === null || result === void 0 ? void 0 : result.state) === SearchResultState.LOADED &&
        (terms === null || terms === void 0 ? void 0 : terms.find(function (term) {
            if (term.title.toLowerCase() === (query === null || query === void 0 ? void 0 : query.toLowerCase())) {
                return true;
            }
            if (Array.isArray(term === null || term === void 0 ? void 0 : term.alias) && (term === null || term === void 0 ? void 0 : term.alias.find(function (a) { return a.toLowerCase() === (query === null || query === void 0 ? void 0 : query.toLowerCase()); }))) {
                return true;
            }
            return false;
        }));
    return (React.createElement(SearchContainer, null,
        React.createElement(RowLayout, { gutter: matchedTerm ? 2 : 5, paddingY: 10 },
            React.createElement(Text, { variant: "h1" }, title),
            matchedTerm && React.createElement(GlossaryTermWidget, __assign({}, matchedTerm)),
            React.createElement(SearchResults, { results: (_c = (_b = result === null || result === void 0 ? void 0 : result.response) === null || _b === void 0 ? void 0 : _b.records) === null || _c === void 0 ? void 0 : _c.page, state: result === null || result === void 0 ? void 0 : result.state, count: (_d = result === null || result === void 0 ? void 0 : result.response) === null || _d === void 0 ? void 0 : _d.record_count, onSelect: selectResult })),
        (result === null || result === void 0 ? void 0 : result.state) === SearchResultState.LOADED && (React.createElement(Pagination, { activePage: page, pageCount: (_g = (_f = (_e = result === null || result === void 0 ? void 0 : result.response) === null || _e === void 0 ? void 0 : _e.info) === null || _f === void 0 ? void 0 : _f.page) === null || _g === void 0 ? void 0 : _g.num_pages, onChange: handlePageChange }))));
};
